// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1_v20","messages":"Chat_messages__J3F3A","dateDivider":"Chat_dateDivider__3yn4a"};